import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/tip_icon.png';

const _withScopeId = n => (_pushScopeId("data-v-137595a6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "del-dialog-wrapper"
};
const _hoisted_2 = {
  class: "del-content"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));

const _hoisted_4 = {
  class: "tip-text"
};
const _hoisted_5 = {
  class: "text"
};
const _hoisted_6 = {
  class: "tip"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("确定");

export default {
  props: {
    show: Boolean,
    courseId: String,
    // 操作类型 0 课程 1 教案 2 同意加入协作 3 拒绝加入协作
    actionType: {
      type: Number,
      default: 0
    }
  },
  emits: ["update:show", 'confirmDel'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const $http = inject("$http");
    const tipTitle = computed(() => {
      if (props.actionType === 0) {
        return '是否删除课程？';
      } else if (props.actionType === 1) {
        return '是否删除教案？';
      } else if (props.actionType === 2) {
        return '确定加入案例协作吗?';
      } else {
        return '确定拒绝案例协作邀请吗?';
      }
    });
    const tipText = computed(() => {
      if (props.actionType === 0) {
        return '删除课程后将不可恢复';
      } else if (props.actionType === 1) {
        return '删除教案后将不可恢复';
      } else if (props.actionType === 2) {
        return '加入后，将可以参与案例协作设计';
      } else {
        return '拒绝后，将无法进行案例协作';
      }
    });

    const handleClose = () => {
      emit("update:show", false);
    }; // 确认删除


    const handleConfirm = async () => {
      emit("confirmDel");
      handleClose();
    };

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: __props.show,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(show) ? show.value = $event : null),
        width: "480px",
        title: "提示",
        "before-close": handleClose,
        "destroy-on-close": "",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_button, {
          size: "large",
          onClick: handleClose
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          onClick: handleConfirm
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_unref(tipTitle)), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(tipText)), 1)])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};